import { StorageType } from '../models/base-classes';
import { Injectable } from '@angular/core';
interface IStorageService {
    save<T>(keyName: string, value: T, storageType: StorageType): void;
    get<T>(keyName: string, storageType: StorageType): T;
}

@Injectable()
export class StorageService implements IStorageService {
    constructor() {
    }

    public save<T>(keyName: string, value: T, storageType: StorageType = StorageType.localStorage): void {
        let data = JSON.stringify(value);
        switch (storageType) {
            case StorageType.session:
                sessionStorage.setItem(keyName, data);
                break;
            default:
                localStorage.setItem(keyName, data);
                break;
        }
    }

    public get<T>(keyName: string, storageType: StorageType = StorageType.localStorage): T {
        switch (storageType) {
            case StorageType.session:
                return JSON.parse(sessionStorage.getItem(keyName) as string) as T;
            default:
                return JSON.parse(localStorage.getItem(keyName) as string) as T;
        }
    }

    public clear(keyName: string, storageType: StorageType = StorageType.localStorage): void {
        switch (storageType) {
            case StorageType.session:
                sessionStorage.removeItem(keyName);
                break;
            default:
                localStorage.removeItem(keyName);
                break;
        }
    }
}